const generateRandomId = () => Number(Math.random().toString().substr(2, 6));

export default generateRandomId;
